var React = require('react');

function ClockInline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"16.0002","cy":"16","r":"12.8","stroke":"#EC5344","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M16 9.59998V16L20.8 19.2","stroke":"#EC5344","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

ClockInline.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = ClockInline;

ClockInline.default = ClockInline;
